import { BandAvailabilityDto } from "@/src/web-api-client";

interface Props {
  title: string;
  slots: BandAvailabilityDto[];
  selectedTime: BandAvailabilityDto;
  handleTimeSelect: (time: BandAvailabilityDto) => void;
}

export default function TimeSlotGroup({
  title,
  slots,
  selectedTime,
  handleTimeSelect,
}: Props) {
  if (slots.length === 0) return null;

  return (
    //DESKTOP

    <div className="mb-4">
      <h4 className="text-lg font-semibold text-gray-800 mb-3">{title}</h4>
      <div className="grid grid-cols-3 md:grid-cols-4 gap-3">
        {slots.map((band: BandAvailabilityDto, idx) => (
          <button
            key={idx}
            onClick={() => handleTimeSelect(band)}
            className={`p-2 rounded-lg border-2 font-medium transition-all duration-200 
              ${
                selectedTime === band
                  ? "color-primary text-white border-emerald-500"
                  : "bg-white text-gray-700 border-emerald-200 hover:border-emerald-500"
              }`}
          >
            {band.range}
          </button>
        ))}
      </div>
    </div>
  );
}
